import { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import AuthHelper from "components/auth/helpers";
import Error from "components/error-handling/ErrorToLogout";
import GlobalLayout from "components/layout/global-layout";
import Modal from "antd/lib/modal/Modal";
import { Button, Space } from "antd";
import welcomeGraphic from "assets/images/welcome-graphic.png";
import { setWelcomeModal } from "redux/reducers/PropertiesSlice";
import { useDispatch } from "react-redux";
import { useAppSelector } from "redux/hooks";
import { useTranslation } from "react-i18next";
import { fetchSchoolContact } from "redux/reducers/SchoolContactSlice";
import moment from "moment";
import { isEmpty } from "lodash";
import NotFound from "pages/school-user/not-found";
import useFilteredNavMenus from "utils/hooks/useFilteredNavMenus";

const SchoolUser: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { filteredNavMenus } = useFilteredNavMenus({ isDisplayMenu: false });
  const { showWelcomeModal } = useAppSelector(state => state.properties);
  const { email } = useAppSelector(state => state.schoolContact.data);
  const accessToken = AuthHelper.getAuth()?.accessToken;
  const strAccessTokenExpireTime =
    localStorage.getItem(AuthHelper.TOKEN_EXPIRE_TIME) || moment().subtract(1, "seconds").format();

  const checkShouldFetchSchoolContact = () => {
    if (!isEmpty(email)) {
      return false;
    }
    const accessToken = AuthHelper.getAuth()?.accessToken;
    if (!accessToken) {
      return false;
    }

    const inLocalStorage = localStorage.getItem(AuthHelper.TOKEN_EXPIRE_TIME);
    const strAccessTokenExpireTime = inLocalStorage || moment().subtract(1, "seconds").format();
    const accessTokenExpireTime = moment(strAccessTokenExpireTime);
    if (!accessTokenExpireTime.isAfter(moment())) {
      return false;
    }
    return true;
  };

  const handleStorageChange = () => {
    if (checkShouldFetchSchoolContact()) {
      dispatch(fetchSchoolContact());
    }
  };

  useEffect(() => {
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [handleStorageChange]);

  useEffect(() => {
    if (checkShouldFetchSchoolContact()) {
      dispatch(fetchSchoolContact());
    }
  }, [email, accessToken, strAccessTokenExpireTime]);

  useEffect(() => {
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [handleStorageChange]);

  return (
    <GlobalLayout>
      <Modal
        open={showWelcomeModal}
        footer={null}
        width={572}
        bodyStyle={{ padding: 56 }}
        onCancel={() => {
          dispatch(setWelcomeModal(false));
        }}
      >
        <div style={{ width: "100%" }} className="center-justify">
          <Space direction="vertical" align="center" size={24}>
            <img src={welcomeGraphic} alt="" style={{ maxWidth: 252 }} />
            <h1 style={{ fontSize: 38, marginBottom: 0, lineHeight: "46px", textAlign: "center" }}>
              {t("welcomeModal.heading")}
            </h1>
            <p style={{ marginBottom: 0, textAlign: "center" }}>{t("welcomeModal.description")}</p>
            <Button
              type="primary"
              onClick={() => {
                dispatch(setWelcomeModal(false));
              }}
            >
              {t("welcomeModal.button")}
            </Button>
          </Space>
        </div>
      </Modal>
      {AuthHelper.isAuthed() && AuthHelper.isSchoolUser() ? (
        <Switch>
          {filteredNavMenus.map(item => {
            const { Page } = item;
            return <Route key={item.url} path={item.url} exact={item.exact} component={Page} />;
          })}
          <Route path="*" component={NotFound} />
        </Switch>
      ) : (
        <Error path={"/"} />
      )}
    </GlobalLayout>
  );
};

export default SchoolUser;
